/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WorkersResponse { 
    workerId?: string | null;
    number: number;
    stratumUrl: string;
    workerName?: string | null;
    password?: string | null;
}

